import React from "react";
import Link from "next/link";
import {
  foundingSpotsLabel,
  useFoundingRemaining,
} from "@/components/FoundingMemberCallout";

/**
 * Full-width strip for the top of high-intent marketing pages (home,
 * /templates, /tools). The count comes from the shared hook in
 * FoundingMemberCallout.
 */
export default function FoundingMemberBanner() {
  const availability = useFoundingRemaining();

  return (
    <Link
      href="/founding-members"
      className="group block border-b border-amber-200 bg-gradient-to-r from-amber-50 via-white to-violet-50"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-center gap-2 px-6 py-3 text-center sm:flex-row sm:gap-4">
        <span className="rounded-full bg-amber-400 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.13em] text-amber-950">
          Founding Member offer
        </span>
        <span className="text-[13.5px] font-bold text-slate-900">
          Never pay monthly for a CRM again.
        </span>
        <span className="text-[12.5px] font-semibold text-violet-700" aria-live="polite">
          {foundingSpotsLabel(availability)}
        </span>
        <span className="text-[12.5px] font-bold text-indigo-600 group-hover:text-indigo-500">
          See the offer →
        </span>
      </div>
    </Link>
  );
}
